<template>
  <div>
    <div class="checkout">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <h5
              class="checkout-title text-center mt-4 mb-4"
              style="font-size: 2.5rem"
            >
              Reset Password
            </h5>
            <!-- End .checkout-title -->

            <div class="card border">
              <form @submit.prevent="reset_password">
                <div class="card-body pl-5 pr-5">
                  <div class="m-4" v-if="error">
                    <AlertComponent :message="error" :alert-type="'danger'" />
                  </div>
                  <div class="mt-2">
                    <label for="email" class="text-center"
                      >E-Mail Address</label
                    >

                    <input
                      id="email"
                      type="email"
                      class="form-control"
                      name="email"
                      v-model="form.email"
                      placeholder="Inserisci la tua email"
                      readonly
                      autofocus
                    />

                    <div class="alert alert-danger" v-if="errors.email">
                      {{ errors.email[0] }}
                    </div>
                  </div>

                  <div class="mt-2">
                    <label for="password" class="text-center">Password</label>

                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      name="password"
                      v-model="form.password"
                      placeholder="Inserisci la nuova password"
                    />

                    <div class="alert alert-danger" v-if="errors.password">
                      {{ errors.password[0] }}
                    </div>
                  </div>

                  <div class="mt-2">
                    <label for="password-confirmation" class="text-center"
                      >Confirm Password</label
                    >

                    <input
                      id="password-confirmation"
                      type="password"
                      class="form-control"
                      name="password_confirmation"
                      placeholder="Conferma la password "
                      v-model="form.password_confirmation"
                    />

                    <div
                      class="alert alert-danger"
                      v-if="errors.password_confirmation"
                    >
                      {{ errors.password_confirmation[0] }}
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="mt-1 mb-1 text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      v-if="!disabled"
                    >
                      Reset Password
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary disabled"
                      v-if="disabled"
                    >
                      Reset Password
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import AlertComponent from "@/components/AlertComponent.vue";
import http from "@/services/http.js";
import router from "@/router";
export default {
  name: "RequestResetPassword",
  components: { AlertComponent },
  props: ["token"],
  /*setup() {
      const router = 
    },*/
  data() {
    return {
      form: {
        email: "",
        password: "",
        password_confirmation: "",
        token: "",
      },
      errors: [],
      error: "",
      user: "",
      successMessage: "",
      disabled: false,
    };
  },
  async mounted() {
    this.form.token = this.token;
    await http
      .get("/get-token/" + this.token)
      .then((response) => {
        if (response.data.status) {
          this.form.email = response.data.data.email;
        } else {
          this.error = response.data.message;
        }
      })
      .catch((error) => {
        if (error.response.status == 402) {
          this.error = error.response.data.message;
        }
      });
  },
  methods: {
    async reset_password() {
      this.successMessage = "";
      this.error = "";
      if (!this.disabled) {
        await http.post("/reset-password", this.form).then((response) => {
          if (response.data.status) {
            this.form.email = "";
            this.form.password = "";
            this.form.password_confirmation = "";
            this.disabled = true;
            localStorage.setItem("successMessageReset", response.data.message);
            router.push("/");
          } else {
            this.error = response.data.message;
          }
        });
      }
    },
  },
};
</script>